<template>
    <input
        type="text"
        class="kgr-input"
        :class="{ 'has-errors': error || errorState, 'kgr-input--inline': inline }"
        :value="val"
        :disabled="disabled"
        @input="updateValue($event.target.value)"
    />
</template>

<script>
import Time from '../../../../js/date/Time';

export default {
    props: {
        value: {
            type: String,
            example: '10:30',
        },
        inline: {
            type: Boolean,
            required: false,
        },
        errorState: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            val: null,
            error: false,
        };
    },
    watch: {
        value: {
            handler(value) {
                try {
                    this.val = Time.fromString(value).toString();
                    this.error = false;
                } catch (error) {
                    this.$emit('error');
                    this.error = true;
                }
            },
            immediate: true,
        },
    },
    mounted() {
        const input = $(this.$el);
        input.timepicker({
            showPeriodLabels: false,
        });
        input.on('change', (event) => this.updateValue(event.target.value));
    },
    methods: {
        updateValue(value) {
            this.val = value;
            try {
                const time = Time.fromString(value);

                this.$emit('change', time);
                this.error = false;
            } catch (error) {
                this.$emit('error');
                this.error = true;
            }
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    input {
    width: 71px;
}

.has-errors {
    border: 1px solid red !important;
}
</style>
